import { createContext } from "react";
const SplashScreenContext = createContext({});
export default SplashScreenContext;